import React, {Component} from "react";

class Divider extends Component {
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="divider" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Divider;